import React, { useState, useEffect, useCallback, useMemo } from "react";
import { TextField, Typography, FormControl, RadioGroup, FormLabel, FormControlLabel, Radio, MenuItem, Box } from "@mui/material";
import { ModelCreation } from "../../services/types";
import { createModel } from "../../services/apiService";
import { useNavigate, useLocation } from "react-router-dom";
import { showToast } from "../Toast/CommonToast";
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";
import { createInfluencer, getModelName, influncerSelectedImages } from "../../services/apiService";
import { useAIInfluencerCharacterWebSocket } from '../../context/AIInfluencerCharacterProvider';
import AddIcon from '@mui/icons-material/Add';
import CommonPopup from '../Popup/Popup';
import SecondaryButton from "../Reusable/SecondaryButton/SecondaryButton";
import './AIInfluencer.css';
import LoaderWithBackdrop from "../Loader/loader";
import { useCreditPoints } from "../../services/CreditPointsProvider";
import VoicePopup from "../Popup/VoicePopup/VoicePopup";
import VoiceConfirmation from "../VoiceConfimation/VoiceConfimation";
import { getAllAudioDetails } from "../../services/apiService";
import VoiceSelector from "../Studio/VoiceSelector";
import InstructionPopup from "../Popup/VoicePopup/InstructionPopup";


interface FormErrors {
  modelName?: string;
  modelType?: string;
  uniquePersonName?: string;
}
const genders = ['Male', 'Female', 'Other'];


const ShowcaseAddModels = React.memo(() => {
  // VoiceSelector state and handlers
  const [playingVoiceId, setPlayingVoiceId] = useState<string | null>(null);
  const audioRef = React.useRef<HTMLAudioElement | null>(null);
  const [selectedVoice, setSelectedVoice] = useState<string>("");
  const [voiceDocId, setVoiceDocId] = useState<string>("");
  const [instructionPopupOpen, setInstructionPopupOpen] = useState(false);

  console.log("selectedVoice", selectedVoice, voiceDocId)

  const handlePlayPauseVoice = (voice: any) => {
    if (playingVoiceId === voice.voice_id) {
      setPlayingVoiceId(null);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    } else {
      setPlayingVoiceId(voice.voice_id);
      const audioUrl = voice.previewUrl || voice.preview_url || voice.sampleAudioUrl || voice.url || voice.previewUrlBlob;
      if (audioUrl) {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
        const audio = new window.Audio(audioUrl);
        audioRef.current = audio;
        audio.play();
        audio.onended = () => setPlayingVoiceId(null);
      } else {
        console.warn('No valid audio URL found for voice:', voice);
      }
    }
  };

  const onVoiceChange = (voiceId: string, voice: any) => {
    console.log("onVoiceChange called with voiceId:", voiceId, "and voice:", voice);
  setSelectedVoice(voiceId);
  setVoiceDocId(voice && voice._id ? voice._id : "");
  };
  const [modelName, setModelName] = useState("");
  const [modelType, setModelType] = useState("");
  const [uniquePersonName, setUniquePersonName] = useState("");
  const [errors, setErrors] = useState<FormErrors>({});
  const [isLoading, setIsLoading] = useState(false);
  const [formType, setFormType] = useState<'addModel' | 'AiInfluencer'>('addModel');
  const [formData, setFormData] = useState({
    ethnicity: '',
    age: '',
    gender: '',
    hair: '',
  });
  const [createAIinfluncer, setCreateInfluencer] = useState<any[]>([]);
  const [characterPopupOpen, setCharacterPopupOpen] = useState(false);
  const [eventId, setEventId] = useState<string>('');
  const [eventIDDetails, setEventIdDetails] = useState<any[]>([]);

  const location = useLocation();
  const navigate = useNavigate();
  const userId = useMemo(() => localStorage.getItem("userId") || "", []);

  const { reconnectWebSocket, responseData, arrayofResponseData } = useAIInfluencerCharacterWebSocket();
  const { fetchCreditPoints } = useCreditPoints();
  const [voicePopupOpen, setVoicePopupOpen] = useState(false);
  const [confimationVoicePopup, setConfimationnVoicePopup] = useState(false)
  // const [voiceClone, setVoiceClone] = useState<any>(false);
    const [recording, setRecording] = useState(false);
    const [audioURL, setAudioURL] = useState<string | null>(null);
    const [insertedId, setInsertedId] = useState<string>("");
   const [defaultVoices, setDefaultVoices] = useState<any[]>([]);
   const [voiceConfirm, setVoiceConfirm] = useState<'yes' | 'no'>('no')


    const handleGetVoices = async()=>{
      try{
        const response = await getAllAudioDetails();
        console.log("response", response?.data)
       setDefaultVoices(response?.data);
      }catch(err:any){
        console.log("error", err)
      }
    }
    React.useEffect(()=>{
      handleGetVoices();
    },[])

  // Memoized style objects to prevent re-creation on every render
  const containerStyle = useMemo(() => ({
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "flex-start" as const,
    minHeight: "100vh",
    backgroundColor: "transparent",
    padding: "20px",
    position: "relative" as const,
    bottom: '40px',
    overflowY: 'auto' as const,
    maxHeight: 'calc(100dvh - 160px)'
  }), []);

  const formContainerStyle = useMemo(() => ({
    width: "70%",
    maxWidth: "800px",
    minWidth: '350px',
    backgroundColor: "transparent",
    padding: "20px",
    borderRadius: "20px"
  }), []);

  const titleStyle = useMemo(() => ({
    color: "white",
    fontWeight: "400",
    fontFamily: "var(--font-family-primary)",
    fontSize: "28px",
    marginBottom: "10px",
  }), []);

  const descriptionStyle = useMemo(() => ({
    color: "white",
    fontWeight: "400",
    fontFamily: "var(--font-family-primary)",
    fontSize: "15px",
    marginBottom: "20px",
  }), []);

  const borderStyle = useMemo(() => ({
    border: '1px solid grey',
    padding: '20px',
    borderRadius: "21px"
  }), []);

  const buttonContainerStyle = useMemo(() => ({
    display: "flex",
    marginTop: "20px",
    gap: "10px"
  }), []);

  // Console logs moved to useEffect with proper dependencies
  useEffect(() => {
    console.log("websocketResponse", responseData);
  }, [responseData]);

  useEffect(() => {
    console.log("arrayofResponseData", arrayofResponseData);
  }, [arrayofResponseData]);

  // Optimized useEffect for arrayofResponseData
  useEffect(() => {
    if (arrayofResponseData && Array.isArray(arrayofResponseData) && arrayofResponseData.length > 0) {
      setCreateInfluencer(arrayofResponseData);
    }
  }, [arrayofResponseData]);

  // useEffect(() => {
  //   if (responseData) {
  //     setCreateInfluencer((prev) => {
  //       if (Array.isArray(responseData) && responseData.length > 0) {
  //         return [...prev, ...responseData];
  //       }
  //       return prev;
  //     });
  //   }
  // }, [responseData])

  useEffect(() => {
      console.log("location", location.state.modelName);

    if (location.state?.modelName) {
      setModelType(location.state.modelName);
      // setFormType(location.state.modelName);
    }
  }, [location.state]);

  // Memoized validation function
  const validateForm = useCallback(() => {
    const formErrors: FormErrors = {};

    if (!modelName.trim()) formErrors.modelName = "Model name is required.";
    if (!modelType) formErrors.modelType = "Model type is required.";
    if (!uniquePersonName.trim()) formErrors.uniquePersonName = "Unique model name is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  }, [modelName, modelType, uniquePersonName]);

  // Memoized submit handler
const handleSubmit = useCallback(async () => {
  if (!validateForm()) return;

  const model: ModelCreation = {
    userId: userId,
    name: modelName,
    type: modelType,
    description: uniquePersonName,
  };
  
  console.log("model", model, "voiceConfirm:", voiceConfirm);

  try {
    const createModelResponse = await createModel(model);
    console.log("createModelResponse", createModelResponse);

    if (createModelResponse.status === "success") {
      const insertedModelId = createModelResponse.data.insertedId;
      
      // Check voiceConfirm state
      if (voiceConfirm === 'yes') {
        // User wants to add voice
        setInsertedId(insertedModelId);
        setConfimationnVoicePopup(true); // Show confirmation dialog
        showToast("Model created successfully", "success");
      } else {
        // User doesn't want voice, redirect immediately
        showToast("Model created successfully", "success");
        const redirectPath = modelType !== "Person" 
          ? `/aipersona/model/${insertedModelId}` 
          : `/humanpersona/model/${insertedModelId}`;
        
        console.log("Redirecting to:", redirectPath);
        navigate(redirectPath);
      }
    }
  } catch (error) {
    console.error("Error creating model:", error);
    showToast("Error creating model", "error");
  }
}, [validateForm, userId, modelName, modelType, uniquePersonName, navigate, voiceConfirm]);

  // Memoized form change handler
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  // Memoized radio change handler
  const handleRadioChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === 'AiInfluencer') {
      setFormType('AiInfluencer');
      setModelType('AiInfluencer');
    } else {
      setFormType('addModel');
      setModelType(value);
    }
  }, []);

  // Events API effect
  useEffect(() => {
    const getEventModelDetails = async () => {
      try {
        const response = await getModelName('showcase');
        
        if (response.status === "success") {
          setEventIdDetails(response.data);
          const event = response.data.find((event: any) => event.eventName === 'Character creation');
          const eventId = event?._id || '683422b3227c23ad8919e8be';
          localStorage.setItem("aiInfluencerCharacterID", eventId);
          if (event) setEventId(eventId);
        }
      } catch (error: any) {
        showToast(error.message, "error");
      }
    };
    
    getEventModelDetails();
  }, [formType]);

  // Memoized eventID calculation
  const eventID = useMemo(() => {
    const event = eventIDDetails.find((event: any) => event.eventName === 'Character variations');
    const id = event?._id;
    if (id) {
      localStorage.setItem("aiVariationID", id);
    }
    return id;
  }, [eventIDDetails]);

  // Memoized create model handler
  const handleCreateModel = useCallback(async () => {
    reconnectWebSocket(eventId);
    setIsLoading(true);
    
    try {
      const model = {
        userId: userId,
        eventId: eventId,
        name: modelName,
        type: formType,
        ethnicity: formData.ethnicity,
        age: formData.age,
        gender: formData.gender,
        hair: formData.hair,
        aspectRatio: '1:1',
        uniqueModelName: uniquePersonName,
      };
      const response = await createInfluencer(model);
      setIsLoading(false);
      if (response.status === "success") {
        showToast("Model created successfully", "success");
        setCharacterPopupOpen(true);
        // Set the image URL from the first imageGenerationId item
        const imageUrl = response.data?.imageGenerationId?.[0]?.url || '';
        setFormData(prev => ({
          ...prev,
          image: imageUrl
        }));
        setCreateInfluencer(response.data?.imageGenerationId?.data || []);
      } else {
        showToast(response.message || "Failed to create model", "error");
      }
    } catch (error: any) {
      setIsLoading(false);
      showToast(error.message || "An error occurred while creating model", "error");
    } finally {
      setIsLoading(false);
    }
  }, [reconnectWebSocket, eventId, userId, modelName, formType, formData, uniquePersonName]);

  // Memoized cancel handler
  const handleCancel = useCallback(() => {
    setFormData({
      ethnicity: '',
      age: '',
      gender: '',
      hair: '',
    });
    setModelName('');
    setUniquePersonName('');
  }, []);

  // Memoized show more images handler
  const handleShowMoreImages = useCallback(async () => {
    setIsLoading(true);
    reconnectWebSocket(eventId);
    
    try {
      const model = {
        userId: userId,
        eventId: eventId,
        name: modelName,
        type: formType,
        ethnicity: formData.ethnicity,
        age: formData.age,
        gender: formData.gender,
        hair: formData.hair,
        aspectRatio: '1:1',
        uniqueModelName: uniquePersonName,
      };
      
      const response = await createInfluencer(model);
      setIsLoading(false);
      if (response.status === "success") {

        setCreateInfluencer(response.data?.imageGenerationId?.data || []);
        setCharacterPopupOpen(true);
      } else {
        showToast("Failed to fetch more images", "error");
      }
    } catch (error: any) {
      setIsLoading(false);
      showToast(error.message || "An error occurred while fetching more images", "error");
    } finally {
      setIsLoading(false);
    }
  }, [reconnectWebSocket, eventId, userId, modelName, formType, formData, uniquePersonName]);

  // Memoized proceed images handler
  const proceedImages = useCallback(async (selectedImageIds?: string[]) => {
    if (!selectedImageIds || selectedImageIds.length === 0) return;
    
    try {
      const imageIds = selectedImageIds.length > 0 ? selectedImageIds : '';
      const payLoad: any = {
        userId: userId,
        eventId: eventId,
        name: modelName,
        type: formType,
        ethnicity: formData.ethnicity,
        age: formData.age,
        gender: formData.gender,
        hair: formData.hair,
        aspectRatio: '1:1',
        imageIds: imageIds,
        prompt: createAIinfluncer.length > 0 ? (createAIinfluncer[0] as any).inputData?.prompt : '',
        referenceImageUrl: createAIinfluncer.length > 0 ? (createAIinfluncer[0] as any).url || (createAIinfluncer[0] as any).imageUrl || '' : '',
      };
      if (voiceDocId) {
        payLoad.voiceDocId = voiceDocId;
      }
      const selectedImages = await influncerSelectedImages(payLoad);
      setCreateInfluencer(selectedImages.data[0] || []);
      fetchCreditPoints(userId);

      if (selectedImages) {
        navigate(`/aipersona/model/${selectedImages?.data[0].userModelId}`, {
          state: {
            modelType: 'AiInfluencer',
            createAIinfluncer: selectedImages?.data[0],
            eventID: eventID
          }
        });
      }
    } catch (error: any) {
      showToast(error.message || "An error occurred while proceeding with images", "error");
    }
  }, [userId, eventId, modelName, formType, formData, createAIinfluncer, fetchCreditPoints, navigate, eventID, voiceDocId]);

  // Memoized navigation handler
  const handleNavigateBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  // Memoized popup close handler
  const handlePopupClose = useCallback(() => {
    setCharacterPopupOpen(false);
  }, []);

  // Memoized form validation checks
  const isCreateModelDisabled = useMemo(() => {
    return !modelName || !formData.ethnicity || !formData.age || !formData.gender || !formData.hair;
  }, [modelName, formData.ethnicity, formData.age, formData.gender, formData.hair]);

  const isAddModelDisabled = useMemo(() => {
    return !modelName || !modelType || !uniquePersonName;
  }, [modelName, modelType, uniquePersonName]);

  return (
    <div style={containerStyle}>
      {isLoading && <LoaderWithBackdrop open={isLoading} />}
      <div>
        <div style={formContainerStyle}>
          <div className="titleContainer">
            <Typography variant="h6" style={titleStyle}>
              Create a Persona
            </Typography>
          </div>
 
          <Typography variant="body1" style={descriptionStyle}>
            Train an AI persona on photos of yourself. It takes 20-30 minutes to train a persona. Then you can generate photos in a variety of settings. We have a lot of templates.
          </Typography>

          <div style={borderStyle}>
            <Box>
              <TextField
                label="Enter persona name"
                variant="outlined"
                value={modelName}
                onChange={(e) => setModelName(e.target.value)}
                error={!!errors.modelName}
                helperText={errors.modelName}
                className="textField width-full"
                sx={{ mb: 2 }}
              />
              <FormControl
                sx={{
                  width: "100%",
                  mb: 2,
                  ".MuiFormLabel-root": { color: "#B3B0c1" },
                  ".MuiFormLabel-root.Mui-focused": { color: "gray" },
                  ".Mui-disabled": {
                    color: "#fffcfc !important",
                    opacity: "inherit !important",
                    "-webkit-text-fill-color": "#fffcfc !important",
                  },
                  ".MuiSvgIcon-root": {
                    color: "#B3B0c1",
                  },
                }}
                error={!!errors.modelType}
              >
                <FormLabel id="radio-group-label">Select persona type</FormLabel>
                <RadioGroup
                  aria-labelledby="radio-group-label"
                  value={modelType}
                  onChange={handleRadioChange}
                  row
                  className="radio-group"
                >
                  <FormControlLabel
                    value="Person"
                    control={<Radio sx={{ color: "gray", "&.Mui-checked": { color: "black" } }} />}
                    label="Human Persona"
                  />
                  <FormControlLabel value="AiInfluencer" control={<Radio />} label="AI Persona" />
                </RadioGroup>
                {errors.modelType && (
                  <Typography variant="caption" color="error">
                    {errors.modelType}
                  </Typography>
                )}
              </FormControl>
 
              <TextField
                label="Unique persona  name"
                variant="outlined"
                value={uniquePersonName}
                onChange={(e) => setUniquePersonName(e.target.value)}
                error={!!errors.uniquePersonName}
                helperText={errors.uniquePersonName}
                className="textField width-full"
                sx={{ mb: 2 }}
              />
            </Box>
                         {/* <FormControl
                          sx={{
                  width: "100%",
                  mb: 2,
                  ".MuiFormLabel-root": { color: "#B3B0c1" },
                  ".MuiFormLabel-root.Mui-focused": { color: "gray" },
                  ".Mui-disabled": {
                    color: "#fffcfc !important",
                    opacity: "inherit !important",
                    "-webkit-text-fill-color": "#fffcfc !important",
                  },
                  ".MuiSvgIcon-root": {
                    color: "#B3B0c1",
                  },
                }}
                         >
                <FormLabel className="radio-group"> Add Voice</FormLabel>
              <RadioGroup
                aria-labelledby="cloneVoice"
                value={voiceClone ? "unique" : "not-unique"}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "unique") {
                    setVoiceClone(true);
                    setVoicePopupOpen(true);
                  } else if (value === "not-unique") {
                    setVoiceClone(false);
                    setVoicePopupOpen(false);
                    setAudioURL(null);
                    setRecording(false);
                  }
                }}
                row
                className="radio-group"
              >
                <FormControlLabel
                  value="unique"
                  control={<Radio sx={{ color: "gray", "&.Mui-checked": { color: "black" } }} />}
                  label="True"
                />
                <FormControlLabel value="not-unique" control={<Radio />} label="False" />
              </RadioGroup>
              </FormControl> */}
            {modelType === 'AiInfluencer' && (
              <Box className='influencerForm' sx={{ width: '100%', mt: 2 }}>
                <TextField
                  label="Ethnicity"
                  name="ethnicity"
                  value={formData.ethnicity}
                  onChange={handleChange}
                  fullWidth
                  placeholder="indian, japanese, etc."
                  className='textField width-full'
                  sx={{ mb: 2 }}
                />
                <TextField
                  label="Age"
                  name="age"
                  type="text"
                  value={formData.age}
                  onChange={handleChange}
                  fullWidth
                  className='textField width-full'
                  sx={{ mb: 2 }}
                />
                <TextField
                  select
                  label="Gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  fullWidth
                  className='textField width-full'
                  sx={{ mb: 2 }}
                >
                  {genders.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Hair"
                  name="hair"
                  value={formData.hair}
                  onChange={handleChange}
                  fullWidth
                  placeholder="black, curly, blonde, etc."
                  className='textField width-full'
                  sx={{ mb: 0 }}
                />
                 <div className="voiceSelectorContainer">
                  <Typography variant="h6" sx={{ color: "#B3B0C1", mb: 1, fontSize: '14px', fontFamily: 'var(--font-family-primary)' }}>Select voice</Typography>
                 <VoiceSelector
  voices={Array.isArray(defaultVoices) ? defaultVoices : []}
  handlePlayPauseVoice={handlePlayPauseVoice}
  playingVoiceId={playingVoiceId}
  selectedVoice={selectedVoice}
  onVoiceChange={onVoiceChange}
/>
                </div>
                <Box className="studioNavFormButtonBox">
                  <ReusableButton
                    variant="contained"
                    onClick={handleCreateModel}
                    icon={<AddIcon />}
                    disabled={isCreateModelDisabled}
                  >
                    Create model (75 Credits)
                  </ReusableButton>
                  <SecondaryButton variant="contained" onClick={handleCancel}>
                    Cancel
                  </SecondaryButton>
                </Box>
              </Box>
             
            )}
            <div>
              {modelType !== 'AiInfluencer' ?(
              <div>
              <VoiceConfirmation 
               credits={450}
               setConfimationnVoicePopup={setConfimationnVoicePopup}
               confimationVoicePopup={confimationVoicePopup}
               setVoicePopupOpen={setVoicePopupOpen}
               voicePopupOpen={voicePopupOpen}
               setInstructionPopupOpen={setInstructionPopupOpen}
               setVoiceConfirm={setVoiceConfirm}
               
                onConfirm={(confirmAddVoice) => {
                  console.log("confirmAddVoice", confirmAddVoice)
                }}
                modelName={modelName}
              />

                </div> ): null
            }
            {formType === 'addModel' && (
              <div style={buttonContainerStyle}>
                <ReusableButton
                  onClick={handleSubmit}
                  icon={<AddIcon />}
                  disabled={isAddModelDisabled}
                >
                  Create model
                </ReusableButton>
                <SecondaryButton onClick={handleNavigateBack}>
                  Cancel
                </SecondaryButton>
              </div>
            )}
            </div>
          </div>
          {voicePopupOpen === true && (
            <VoicePopup
              open={voicePopupOpen}
              onClose={() => setVoicePopupOpen(false)}
              setRecording={setRecording}
              setAudioURL={setAudioURL}
              audioURL={audioURL}
              recording={recording}
              onSubmit={(data: { audioURL: string }) => {
                console.log("data.audioURL", data.audioURL, audioURL)
                setAudioURL(data.audioURL);
              }}
              eventId={eventId}
              modelName={modelName}
              insertedId={insertedId}
              formType={formType}

            />
          )}
          {instructionPopupOpen && (
            <InstructionPopup
              open={instructionPopupOpen}
              onContinue={() => {
                setInstructionPopupOpen(false);
                setVoicePopupOpen(true);
              }}
              onClose={() => { setInstructionPopupOpen(false)}}
               instructions={[
    "Use headphones with a mic in a quiet space for clear audio and minimal echo.",
    "Click Record and speak clearly and naturally for clear voice output.",
    "Ensure you have enough credits before starting"
  ]}
            />
          )}
          {characterPopupOpen && (
            <CommonPopup
              aiInfluencer="AiInfluencer"
              open={characterPopupOpen}
              onClose={handlePopupClose}
              createAIinfluncer={createAIinfluncer}
              setCreateInfluencer={setCreateInfluencer}
              onShowMoreImages={handleShowMoreImages}
              formData={formData}
              eventId={eventId}
              proccedImages={proceedImages}
              modelName={modelName}
              selectionMode="single"
            />
          )}
        </div>
      </div>
    </div>
  );
});

ShowcaseAddModels.displayName = 'ShowcaseAddModels';

export default ShowcaseAddModels;